import Avatar from "@material-ui/core/Avatar";
import useBrand from 'Hooks/useBrand';
import Colors from "modules/Colors";
import { styx } from "modules/Utils";
import clsx from "clsx";
import ProfileIcon from "assets/images/profileIcon.svg";
import { CurrentBrand } from "modules/Types";
import { PlanType } from "modules/Const";
import { CSSProperties } from "react";
import Icon from "elements/Icon";

interface CustomAvatarProps {
    className: string;
    style?: CSSProperties;
    image?: string | null | undefined;
    isBorder?: boolean;
    isDiv?: boolean;
    size?: number;
    brandOverride?: CurrentBrand;
    isGradient?: boolean;
    isTeamAvatar?: boolean;
}

const CustomAvatar = ({
    className,
    style,
    image,
    isBorder = false,
    isDiv,
    size = 40,
    brandOverride,
    isGradient = true,
    isTeamAvatar = false,
}: CustomAvatarProps) => {
    const { getBrandImage } = useBrand();

    let avatarImage = image ? image : ProfileIcon;

    if (brandOverride) {
        avatarImage = getBrandImage(brandOverride); // NOTE CONNER: i'm hoping eventally this getBrandImage will not be necessary
    }

    const avatarSize = { width: size, height: size };

    // If it's a team avatar with no image, show Home icon on purple background
    if (isTeamAvatar && !image) {
        return (
            <div
                className={clsx('customTeamAvatar', className)}
                style={styx(
                    sty.teamAvatarContainer,
                    avatarSize,
                    style
                )}
            >
                <Icon
                    className="teamAvatarHomeIcon"
                    icon="home"
                    size={Math.floor(size * 0.5)}
                    color={Colors.white}
                />
            </div>
        );
    }

    let avatarComponent = (
        <Avatar
            src={avatarImage}
            className={clsx('customAvatarComponent', className)}
            style={styx(
                isBorder && !image ? { border: `2px solid ${Colors.purple}`, backgroundColor: Colors.purple } : null,
                { flexShrink: 0 },
                avatarSize,
                style,
            )}
        />
    )

    if (isGradient) {
        avatarComponent = (
            <div
                className={clsx('customAvatarComponent', className)}
                style={sty.avatarDivOuter}
            >
                <Avatar src={avatarImage} style={avatarSize} />
            </div>
        )
    }

    if (isDiv) {
        return (
            <div className={clsx('customAvatarWithDiv', className)}>
                {avatarComponent}
            </div>
        )
    }

    return avatarComponent;
};

const sty: Record<string, CSSProperties> = {
    avatarDivOuter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        height: 45,
        width: 45,
        background: 'linear-gradient(to top right, #8e33ff 25%, #ff7e33, #ffc300 90%)',
        borderRadius: '50%',
    },
    teamAvatarContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        backgroundColor: Colors.purple,
        borderRadius: '50%',
    }
}

export default CustomAvatar;
